import { Button, Box, Grid, TextField, Typography, Paper, Popover, Stack, Switch } from '@mui/material';
import React, { useState, useEffect } from 'react';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Select from "react-select";
import { axiosFetch } from "../../../utils/AxiosFetch";
import PopupState, { bindToggle, bindPopover } from 'material-ui-popup-state';
import { useDispatch, useSelector } from 'react-redux';
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
import { ChangeTeamModal } from './Index';
import { loadLocation, loadJobTitle } from '../../../redux/actions/lookups.action';
import { CommonModal, ChangePassword, ConfirmationModal } from "../../../shared";
import { profile_details, manager_update } from '../../../redux/actions/user.actions';
import moment from 'moment';

function BasicDetails(props) {
    const dispatch = useDispatch();

    const [isdeptNameEdit, setIsdeptNameEdit] = useState(true)
    const [departments, setDepartments] = useState([]);
    const [deptValue, setDeptValue] = useState("");
    const [deptStatic, setDeptStatic] = useState(props.profile.departmentName)

    const [team, setTeam] = useState(props.profile.teamName)
    const [isTeamEdit, setIsTeamEdit] = useState(true)

    const [isContactEdit, setIsContactEdit] = useState(true)
    const [contactNumber, setContactNumber] = useState(props.profile.phone)
    const [phone, setPhone] = useState(props.profile.phone)

    const [otherEmail, setOtherEmail] = useState(props.profile.secondaryEmails)

    const [isLocationEdit, setIsLocationEdit] = useState(true)
    const [locations, setLocations] = useState([]);
    const [locationValue, setLocationValue] = useState("");
    const [locationStatic, setLocationStatic] = useState(props.profile.location)

    const [isManagerEdit, setIsManagerEdit] = useState(false)
    const [reportingManager, setReportingManager] = useState([]);
    const [ManagerValue, setManagerValue] = useState("");
    // const [managerStatic, setManagerStatic] = useState(props.profile)
    const [isManager, setIsManager] = useState(props.isManager)

    const [jobTitleOption, setJobTitleoption] = useState([]);
    const [jobTitleValue, setJobTitleValue] = useState("");
    const [jobTitleStatic, setJobTitleStatic] = useState(props.profile.jobTitleName);

    const [isJoiningdateEdit, setIsJoiningDate] = useState(true)
    const [joiningDate, setJoiningDate] = useState("")
    const [date, setDate] = useState(moment(props.profile.joiningDate).format('MMM-DD-YYYY'))
    var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";
    const [onlyWarning, setOnlyWarning] = useState(false);
    const [openReprt, setOpenReprt] = React.useState(false);

    const [modalOpen, setModalOpen] = useState(false)
    let LULocation = useSelector(state => state.loadLocation_Reducer.locationList)
    var isManagerUpdate = useSelector(state => state.managerUpdate_Reducer.manager);
    let LUJobTitle = useSelector(state => state.loadJobTitle_Reducer.jobTitleList)
    const [passwordPopup, setPasswordPopup] = useState(false)


    useEffect(() => {
        setIsManager(props.isManager)
    }, [props.isManager])

    useEffect(() => {
        if (LUJobTitle !== undefined) {
            setJobTitleoption(LUJobTitle)
            if (props.profile.jobTitleName) {
                LUJobTitle.filter((option) => {
                    if (props.profile.jobTitleName === option.label) {
                        var value = []
                        value.push(option)
                        setJobTitleValue(value)
                    }
                })

            }
        }
    }, [LUJobTitle, props.profile.jobTitleName])

    useEffect(() => {
        isManagerUpdate = '';
        dispatch(loadLocation());
        dispatch(loadJobTitle())
        fetchDepartmentLookup();
        fetchReportingManagerLookup({
            "departmentId": 0,
            "teamId": 0
        });
    }, []);
    useEffect(() => {
        if (isManagerUpdate.data === "success") {
            setOpenReprt(false)
            dispatch(SnackbarActions(true, "success", "Updated successfully"))
            dispatch(profile_details(props.Id))
        }
    }, [isManagerUpdate])

    useEffect(() => {
        if (LULocation !== undefined) {
            var data = props.profile;
            setLocations(LULocation)
            LULocation.filter((option) => {
                if (data.location === option.label) {
                    var value = []
                    value.push(option)
                    setLocationValue(value)
                }
            })
        }
    }, [LULocation])

    useEffect(() => {
        var data = props.profile;
        setIsManager(props.profile.isManager)
        if (data.departmentId !== null) {
            departments.filter((option) => {
                if (data.departmentId.toString() === option.value) {
                    var value = []
                    value.push(option)
                    setDeptValue(value)
                }
            })
        }
        if (data.location) {
            locations.filter((option) => {
                if (data.location === option.label) {
                    var value = []
                    value.push(option)
                    setLocationValue(value)
                }
            })
        }
        if (data.joiningDate) {
            var value = data.joiningDate;
            var split = value.split("T");
            
            setDate(moment(value).format('MMM-DD-YYYY'))
            setJoiningDate(split[0])
        }
    }, [props.profile])

    const fetchDepartmentLookup = () => {
        axiosFetch({
            method: "GET",
            url: "/lookup/departments",
        })
            .then((res) => {
                if (res.status === 200) {
                    setDepartments(res.data);
                }
                // if (res.status === 400) {
                //     dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
                // }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const fetchReportingManagerLookup = (req) => {
        axiosFetch({
            method: "POST",
            url: "/lookup/reportingmanagers",
            requestConfig: req
        })
            .then((res) => {
                if (res.status === 200) {
                    setReportingManager(res.data);
                }
                // if (res.status === 400) {
                //     dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
                // }
            })
            .catch((error) => {
                console.log(error);
            });
    };


    const updateDepartment = () => {
        setDeptStatic(deptValue.label)
        var req = {
            "TypeId": 1,
            "FieldName": "departmentId",
            "Value": deptValue.value,
            "ItemId": props.Id,
            "TableName": "EmployeeDetails"
        }
        updateDetails(req)
    }
    const updateContact = () => {
        const PHONE_REGEX =
            new RegExp(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/)
        if (PHONE_REGEX.test(phone)) {
            setContactNumber(phone)
            var req = {
                "TypeId": 1,
                "FieldName": "phone",
                "Value": phone,
                "ItemId": props.Id,
                "TableName": "EmployeeDetails"
            }
            updateDetails(req)
        }
        else {
            dispatch(SnackbarActions(true, "error", "Invalid contact number"))
        }


    }
    const updateLocation = () => {
        setLocationStatic(locationValue.label)
        var req = {
            "TypeId": 1,
            "FieldName": "officeLocationId",
            "Value": locationValue.value,
            "ItemId": props.Id,
            "TableName": "EmployeeDetails"
        }
        updateDetails(req)

    }
    const updateDesignation = () => {
        if (jobTitleValue !== "") {
            setJobTitleStatic(jobTitleValue.label)
            var req = {
                "TypeId": 1,
                "FieldName": "jobTitleId",
                "Value": jobTitleValue.value,
                "ItemId": props.Id,
                "TableName": "EmployeeDetails"
            }
            updateDetails(req)
        }
    }
    const updateDate = () => {
        
        setDate(moment(joiningDate).format('MMM-DD-YYYY'))
        var req = {
            "TypeId": 1,
            "FieldName": "joiningDate",
            "Value": joiningDate,
            "ItemId": props.Id,
            "TableName": "EmployeeDetails"
        }
        updateDetails(req)
    }
    const updateDetails = (req) => {
        axiosFetch({
            method: "POST",
            url: "/data/update",
            requestConfig: req,
        })
            .then((res) => {
                if (res.status === 200) {
                    if (res.data === "success") {
                        dispatch(SnackbarActions(true, "success", "Updated successfully"))
                        var close = document.getElementById("closebtn");
                        close.click();
                        dispatch(profile_details(props.Id))
                    }
                }
                if (res.status === 400) {
                    if(res.data === "Email Already exists."){
                        dispatch(SnackbarActions(true, "error", res.data))

                    }
                    else{
                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))

                    }
                }
                if (res.status === 401) {
                    // navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const formatEmployeeId = (id) => {
        var regExp = /[a-zA-Z]/g;
        var testString = id;
        if (id !== null && id !== undefined) {
            if (regExp.test(testString)) {
                var value = String(id.substring(1)).padStart(3, '0');
                return id.at(0) + value;
            } else {
                var empId = id;
                return String(empId).padStart(4, '0');
            }
        }

    }
    const handleValue = (dept, team) => {
        let value = dept;
        if (team) {
            value = dept + " / " + team
        }
        return value
    }
    const handlePopup = () => {
        if (modalOpen) {
            setOnlyWarning(false)
            setModalOpen(false)
        }
        else {
            setModalOpen(true)
        }
    }

    const handleManager = (event) => {
        // setIsManager(event.target.checked)
        var req = {
            "userId": props.Id,
            "isManager": event.target.checked
        }
        if (isManager && props.count > 0) {
            setOnlyWarning(true)
            handlePopup()
        }
        else {
            handleCommonPopup()
        }
    }

    const handleCommonPopup = () => {
        if (openReprt) {
            setOpenReprt(false)
        }
        else {
            setOpenReprt(true)
        }
    }
    const handlePassword = () => {
        if (passwordPopup) {
            setPasswordPopup(false)
        }
        else {
            setPasswordPopup(true)
        }
    }
    const handleManagerRole = () => {
        if (isManager) {
            var req = {
                "userId": props.Id,
                "isManager": false
            }
            dispatch(manager_update(req))
        }
        else {
            var req = {
                "userId": props.Id,
                "isManager": true
            }
            dispatch(manager_update(req))
        }
    }
    const updateOtherEmail = () => {
        var arr = [];
        let regex = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,15}$/);
        let testEmails = otherEmail.split(",")
        testEmails.forEach((address, index) => {
            if (regex.test(address)) {
                // arr.push(index)
            }
            else {
                arr.push(index + 1)
            }
        });
        if (arr.length > 0) {
            var verb;
            if(arr.length > 1){
                verb = "are"
            }
            else{
                verb = "is"
            }
            dispatch(SnackbarActions(true, "error", `Email address ${arr.toString()} ${verb} invalid`))
        }
        else {
            var existEmail;
            testEmails.forEach((val) => {
                if (val === props.profile.emailId) {
                    existEmail = `Email address ${val} already exist`
                }
            })
            if (existEmail === undefined) {
                var req = {
                    "TypeId": 1,
                    "FieldName": "secondaryEmails",
                    "Value": otherEmail,
                    "ItemId": props.Id,
                    "TableName": "EmployeeDetails"
                }
                updateDetails(req)
            }
            else {
                dispatch(SnackbarActions(true, "error", existEmail))
            }

        }
    }
    return (
        <div className='profile-department-container'>
            {props.profile ?
                // <Item  >
                <Box sx={{ textAlign: "left" }}>
                    <Grid container>
                        <Grid item xs={4} className="stensil" sx={{ borderRadius: 4 }}>
                            <h3 className='department-content' data-testid="emp-id">Employee Id</h3>
                        </Grid>
                        {/* <Grid item xs={1}></Grid> */}
                        <Grid container item xs={8} className="stensil" sx={{ borderRadius: 4 }}>
                            <h3 className='department-content' data-testid="emp-id-value">{props.profile.employeeCode !== "0000"? formatEmployeeId(props.profile.employeeCode):"—"}</h3>
                        </Grid>
                        <Grid item xs={4} className="stensil" sx={{ borderRadius: 4 }}>
                            <h3 className='department-content' data-testid="designation">Designation</h3>
                        </Grid>
                        <Grid container item xs={8} className="stensil" sx={{ borderRadius: 4 }}>
                            <Grid item xs={jobTitleStatic !== null ? 8 : 1}>
                                <h3 className='department-content'>{jobTitleStatic !== null ? jobTitleStatic : "—"}</h3>
                            </Grid>
                            {(isUserLogged.usertype === "Admin" ||
                                isUserLogged.usertype === "SuperAdmin"
                                || isUserLogged.usertype === "HRManager"
                                || ((isUserLogged.usertype === "HR" && props.profile.userType !== "HRManager")
                                    && (isUserLogged.usertype === "HR" && props.profile.userType !== "SuperAdmin") &&
                                    (isUserLogged.usertype === "HR" && props.profile.userType !== "Admin"))
                            ) ?
                                <Grid item xs={4}>
                                    <PopupState variant="popper" popupId="demo-popup-popper">
                                        {(popupState) => (
                                            <div>
                                                <IconButton aria-label="edit" size="small" {...bindToggle(popupState)}
                                                >
                                                    <ModeEditIcon className="theme-icon" fontSize="inherit" />
                                                </IconButton>
                                                <Popover {...bindPopover(popupState)} transition classes={{ paper: "MuiPopover-paper" }}>
                                                    <Paper style={{ position: "fixed" }}>
                                                        <Grid container>
                                                            <Grid item xs={8} sx={{ padding: 1 }}>
                                                                <Select
                                                                    placeholder="Select Designation"
                                                                    name="Designation"
                                                                    value={jobTitleValue}
                                                                    options={jobTitleOption}
                                                                    onChange={(selected) => setJobTitleValue(selected)}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={2} sx={{ paddingTop: 1 }}>
                                                                <IconButton color="success" onClick={() => updateDesignation()}>
                                                                    <CheckCircleIcon />
                                                                </IconButton>
                                                            </Grid>
                                                            <Grid item xs={2} sx={{ paddingTop: 1 }}>
                                                                <IconButton id="closebtn" sx={{ color: "red" }} {...bindToggle(popupState)}>
                                                                    <CancelIcon />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Popover>
                                            </div>
                                        )}
                                    </PopupState>
                                </Grid> : ""}
                        </Grid>
                        {/* <Grid item xs={4}  className="stensil">
                        <h3 className='department-content'>Department Name</h3>
                    </Grid>
                    <Grid  container item xs={8} >
                        <Grid item xs={6}>
                        <h3 className='department-content'>{deptStatic}</h3>
                        </Grid>
                        {(isUserLogged.usertype === "Admin")?
                        <Grid item xs={6}>
                            <PopupState variant="popper" popupId="demo-popup-popper">
                                {(popupState) => (
                                    <div>
                                        <IconButton aria-label="edit" size="small" {...bindToggle(popupState)}
                                        >
                                            <ModeEditIcon className="theme-icon" fontSize="inherit" />
                                        </IconButton>
                                        <Popper {...bindPopper(popupState)} transition>
                                            {({ TransitionProps }) => (
                                            <Fade {...TransitionProps} timeout={350}>
                                                <Paper>
                                                <Select 
                                                    placeholder="Select Department"
                                                    name="Department"
                                                    value = {deptValue}
                                                    options={departments}
                                                    onChange = {(selected)=>setDeptValue(selected)}
                                                />
                                                <IconButton color="success" onClick={()=>updateDepartment()}>
                                                    <CheckCircleIcon />
                                                </IconButton>
                                                <IconButton id="closebtn" sx={{ color: "red" }} {...bindToggle(popupState)}>
                                                    <CancelIcon/>
                                                </IconButton>                                            
                                                </Paper>
                                            </Fade>
                                            )}
                                        </Popper>
                                    </div>
                                )}
                            </PopupState>
                        </Grid>:""}
                    </Grid> */}
                        <Grid item xs={4} className="stensil" sx={{ borderRadius: 4 }}>
                            <h3 className='department-content'> Email Address</h3>
                        </Grid>
                        <Grid container item xs={8} className="stensil" sx={{ borderRadius: 4 }}>
                            {/* <Grid item xs={6}> */}
                            <h3 className='department-content' style={{ overflow: 'hidden' }}>{props.profile.emailId}</h3>
                            {/* </Grid>         */}
                        </Grid>
                        <Grid item xs={4} className="stensil" sx={{ borderRadius: 4 }}>
                            <h3 className='department-content'> Other Email Address</h3>
                        </Grid>
                        <Grid container item xs={8} className="stensil" sx={{ borderRadius: 4 }}>
                            <Grid item xs={props.profile.secondaryEmails ? 10 : 1}>
                                {props.profile.secondaryEmails ?
                                    props.profile.secondaryEmails.split(",").map((value) => {
                                        return (
                                            <h3 className='department-content'>{value}</h3>
                                        )
                                    })
                                    : <h3 className='department-content'>—</h3>}
                            </Grid>
                            {
                                (isUserLogged.useremail === props.profile.emailId || isUserLogged.usertype === "Admin" ||
                                    isUserLogged.usertype === "SuperAdmin"
                                    || isUserLogged.usertype === "HRManager"
                                    || ((isUserLogged.usertype === "HR" && props.profile.userType !== "HRManager")
                                        && (isUserLogged.usertype === "HR" && props.profile.userType !== "SuperAdmin") &&
                                        (isUserLogged.usertype === "HR" && props.profile.userType !== "Admin"))
                                ) ?
                                    <Grid item xs={2}>
                                        <PopupState variant="popper" popupId="demo-popup-popper">
                                            {(popupState) => (
                                                <div>
                                                    <IconButton aria-label="edit" size="small" {...bindToggle(popupState)}
                                                    >
                                                        <ModeEditIcon className="theme-icon" fontSize="inherit" />
                                                    </IconButton>
                                                    <Popover {...bindPopover(popupState)} transition classes={{ paper: "MuiPopover-paper" }}>
                                                        <Paper sx={{ padding: 1 }}>
                                                            <TextField id="outlined-basic" label="Other email address" variant="outlined"
                                                                value={otherEmail}
                                                                onChange={(e) => setOtherEmail(e.target.value)} />
                                                            <IconButton color="success" onClick={() => updateOtherEmail()}>
                                                                <CheckCircleIcon />
                                                            </IconButton>
                                                            <IconButton id="closebtn" sx={{ color: "red" }} {...bindToggle(popupState)}>
                                                                <CancelIcon />
                                                            </IconButton>
                                                        </Paper>
                                                    </Popover>
                                                </div>
                                            )}
                                        </PopupState>
                                    </Grid> : ""}
                        </Grid>
                        <Grid item xs={4} className="stensil" sx={{ borderRadius: 4 }}>
                            <h3 className='department-content'> Contact No</h3>
                        </Grid>
                        <Grid container item xs={8} className="stensil" sx={{ borderRadius: 4 }}>
                            <Grid item xs={contactNumber ? 6 : 1}>
                                <h3 className='department-content'>{contactNumber ? contactNumber : "—"}</h3>
                            </Grid>
                            {
                                ( isUserLogged.usertype === "Admin" ||
                                    isUserLogged.usertype === "SuperAdmin"
                                    || isUserLogged.usertype === "HRManager"
                                    || ((isUserLogged.usertype === "HR" && props.profile.userType !== "HRManager")
                                        && (isUserLogged.usertype === "HR" && props.profile.userType !== "SuperAdmin") &&
                                        (isUserLogged.usertype === "HR" && props.profile.userType !== "Admin"))
                                ) ?
                                    <Grid item xs={6}>
                                        <PopupState variant="popper" popupId="demo-popup-popper">
                                            {(popupState) => (
                                                <div>
                                                    <IconButton aria-label="edit" size="small" {...bindToggle(popupState)}
                                                    >
                                                        <ModeEditIcon className="theme-icon" fontSize="inherit" />
                                                    </IconButton>
                                                    <Popover {...bindPopover(popupState)} transition classes={{ paper: "MuiPopover-paper" }}>
                                                        <Paper>
                                                            <TextField id="filled-basic" label="contact number" variant="outlined"
                                                                value={phone}
                                                                onChange={(e) => setPhone(e.target.value)} />
                                                            <IconButton color="success" onClick={() => updateContact()}>
                                                                <CheckCircleIcon />
                                                            </IconButton>
                                                            <IconButton id="closebtn" sx={{ color: "red" }} {...bindToggle(popupState)}>
                                                                <CancelIcon />
                                                            </IconButton>
                                                        </Paper>
                                                    </Popover>
                                                </div>
                                            )}
                                        </PopupState>
                                    </Grid> : ""}
                        </Grid>
                        <Grid item xs={4} className="stensil" sx={{ borderRadius: 4 }}>
                            <h3 className='department-content'>  Reporting Manager</h3>
                        </Grid>
                        <Grid container item xs={8} className="stensil" sx={{ borderRadius: 4 }}>
                            <Grid item xs={6}>
                                <h3 className='department-content'>{props.profile.reportingPersonFirstName ? props.profile.reportingPersonFirstName + " " + props.profile.reportingPersonLastName : ""}</h3>
                            </Grid>
                            {/* <Grid item xs={1}>
                            <IconButton aria-label="edit" size="small">
                                <ModeEditIcon className="theme-icon" fontSize="inherit" />
                            </IconButton></Grid> */}
                        </Grid>
                        <Grid item xs={4} className="stensil" sx={{ borderRadius: 4 }}>
                            <h3 className='department-content'> Office Location</h3>
                        </Grid>
                        <Grid container item xs={8} className="stensil" sx={{ borderRadius: 4 }}>
                            <Grid item xs={locationStatic ? 6 : 1}>
                                <h3 className='department-content'>{locationStatic ? locationStatic : "—"}</h3>
                            </Grid>
                            {
                                ( isUserLogged.usertype === "Admin" ||
                                    isUserLogged.usertype === "SuperAdmin"
                                    || isUserLogged.usertype === "HRManager"
                                    || ((isUserLogged.usertype === "HR" && props.profile.userType !== "HRManager")
                                        && (isUserLogged.usertype === "HR" && props.profile.userType !== "SuperAdmin") &&
                                        (isUserLogged.usertype === "HR" && props.profile.userType !== "Admin"))
                                ) ?
                                    <Grid item xs={6}>
                                        <PopupState variant="popper" popupId="demo-popup-popper">
                                            {(popupState) => (
                                                <div>
                                                    <IconButton aria-label="edit" size="small" {...bindToggle(popupState)}
                                                    >
                                                        <ModeEditIcon className="theme-icon" fontSize="inherit" />
                                                    </IconButton>
                                                    <Popover {...bindPopover(popupState)} transition >
                                                        <Paper style={{ position: "fixed", width: 250 }}>
                                                            <Grid container>
                                                                <Grid item xs={8} sx={{ padding: 1 }}>
                                                                    <Select
                                                                        placeholder="Select Location"
                                                                        name="Location"
                                                                        value={locationValue}
                                                                        options={locations}
                                                                        onChange={(selected) => setLocationValue(selected)}
                                                                        menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={4} sx={{ paddingTop: 1 }}>
                                                                    <IconButton color="success" onClick={() => updateLocation()}>
                                                                        <CheckCircleIcon />
                                                                    </IconButton>
                                                                    <IconButton id="closebtn" sx={{ color: "red" }} {...bindToggle(popupState)}>
                                                                        <CancelIcon />
                                                                    </IconButton>
                                                                </Grid>
                                                            </Grid>
                                                        </Paper>
                                                    </Popover>
                                                </div>
                                            )}
                                        </PopupState>
                                    </Grid> : ""}
                        </Grid>
                        <Grid item xs={4} className="stensil-ignore" >
                            <h3 className='department-content'>Joining Date </h3>
                        </Grid>
                        <Grid container item xs={8} className="stensil-ignore">
                            <Grid item xs={6} className="stensil-ignore">
                                <h3 className='department-content'>{date}</h3>
                            </Grid>
                            {(isUserLogged.usertype === "Admin" ||
                                isUserLogged.usertype === "SuperAdmin"
                                || isUserLogged.usertype === "HRManager"
                                || ((isUserLogged.usertype === "HR" && props.profile.userType !== "HRManager")
                                    && (isUserLogged.usertype === "HR" && props.profile.userType !== "SuperAdmin") &&
                                    (isUserLogged.usertype === "HR" && props.profile.userType !== "Admin"))
                            ) ?
                                <Grid item xs={6}>
                                    <PopupState variant="popper" popupId="demo-popup-popper">
                                        {(popupState) => (
                                            <div>
                                                <IconButton aria-label="edit" size="small" {...bindToggle(popupState)}
                                                >
                                                    <ModeEditIcon className="theme-icon" fontSize="inherit" />
                                                </IconButton>
                                                <Popover {...bindPopover(popupState)} transition classes={{ paper: "MuiPopover-paper" }}>
                                                    <Paper>
                                                        <TextField id="filled-basic" variant="outlined" type="date"
                                                            value={joiningDate}
                                                            onChange={(e) => setJoiningDate(e.target.value)} />
                                                        <IconButton color="success" onClick={() => updateDate()}>
                                                            <CheckCircleIcon />
                                                        </IconButton>
                                                        <IconButton id="closebtn" sx={{ color: "red" }} {...bindToggle(popupState)}>
                                                            <CancelIcon />
                                                        </IconButton>
                                                    </Paper>
                                                </Popover>
                                            </div>
                                        )}
                                    </PopupState>
                                </Grid> : ""}
                        </Grid>
                        <Grid item xs={4} className="stensil-ignore">
                            <h3 className='department-content'>Department / Team </h3>
                        </Grid>
                        <Grid container item xs={8} className="stensil-ignore">
                            {/* <Grid item xs={8}> */}
                            <h3 className='department-content'>{handleValue(deptStatic, team)}</h3>
                            {/* </Grid> */}
                        </Grid>
                        <Grid className="stensil-ignore" container item xs={12} sx={{ display: "flex", alignItems: "center" }}>

                            {isUserLogged.usertype === "Admin" || isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager" ?
                                <>
                                    <Grid item xs={4}>
                                        <h3 className='department-content'>Is Manager?</h3>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <Typography>No</Typography>
                                            <Switch checked={isManager} className="theme-switch" onChange={handleManager} />
                                            <Typography>Yes</Typography>
                                        </Stack>
                                    </Grid>
                                </> : ""}

                        </Grid>
                        {/* <Grid className="stensil-ignore" xs={10} sx={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "15px" }}>
                            
                        </Grid> */}
                        <Grid xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "15px" }}>
                            {(isUserLogged.usertype === "Admin" || isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager") && props.profile.employeeCode !== "0000"?
                                <Button className='theme-btn' sx={{marginRight: "10px"}} variant="contained" onClick={handlePopup}>Change Team</Button> : ""}
                            {(isUserLogged.useremail === props.profile.emailId) ?
                                <Button className='theme-btn' variant="contained" onClick={handlePassword}>Change password</Button> : ""}
                        </Grid>

                    </Grid>
                </Box>
                //  </Item>
                : ""}
            <ChangeTeamModal from="profile" userId={props.Id} open={modalOpen} handleClick={handlePopup} pageData={props.profile} count={props.count} changeManager={onlyWarning} />
            {/* <CommonModal module="ChangeManagerConfirmation" Id={props.Id} openModal={openReprt} handlepopupState={handleCommonPopup} manager={isManager} count={props.count} /> */}
            <ChangePassword handlePasswordPopup={handlePassword} open={passwordPopup} id={isUserLogged.userid} />
            <ConfirmationModal open={openReprt} handleClose={handleCommonPopup} message={"Are you sure you want to change the manager role?"} handleYes={handleManagerRole} />

        </div>
    )
}
export default BasicDetails;